module.exports = __webpack_public_path__ + "static/img/monkey.2901c0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/tables/monkey.jpg
// module id = 645
// module chunks = 0